// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { COLORS } from 'admin/core/theme';

export const ErrorMessage = styled.div`
  font-size: 12px;
  padding: 0;
  margin: 16px 0;
  color: ${COLORS.RED};
`;
